"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _material = require("@mui/material");
var _AppRolesSelect = _interopRequireDefault(require("./AppRolesSelect"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UserAccessForm(_ref) {
  var tenantId = _ref.tenantId,
    company = _ref.company,
    policies = _ref.policies,
    defaultRoles = _ref.defaultRoles,
    onUpdated = _ref.onUpdated,
    onClose = _ref.onClose;
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var companyId = company.id;
  var _useState = (0, _react.useState)(function () {
      return policies.find(function (policy) {
        return policy.company_id === companyId;
      });
    }),
    _useState2 = _slicedToArray(_useState, 1),
    policy = _useState2[0];
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    bind = _useValidatedForm.bind,
    registerInner = _useValidatedForm.registerInner;
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    apps = _useState4[0],
    setApps = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    roles = _useState6[0],
    setRoles = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    disabled = _useState8[0],
    setDisabled = _useState8[1];
  var metadataPromise = (0, _react.useCallback)(function () {
    return (0, _api.getMetadata)({
      companyId: companyId
    }, {
      tenantId: tenantId,
      access: access
    });
  }, [tenantId, access, companyId]);
  var setData = (0, _react.useCallback)(function (metadata) {
    var _a, _b, _c, _d;
    setApps((_c = (_b = (_a = metadata.company) === null || _a === void 0 ? void 0 : _a.apps) === null || _b === void 0 ? void 0 : _b.filter(function (app) {
      return !app.required;
    })) !== null && _c !== void 0 ? _c : []);
    setRoles((_d = metadata.roles) !== null && _d !== void 0 ? _d : []);
    setDisabled(false);
  }, []);
  var onClickedUpdate = (0, _react.useCallback)(function () {
    var request = bind();
    var roles = Object.values(request);
    var roleIds = roles.flatMap(function (el) {
      return el.role_ids;
    });
    onUpdated({
      company_id: companyId,
      role_ids: roleIds
    });
  }, [bind, onUpdated, companyId]);
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('users.accesses.title', {
      name: company.name
    }),
    maxWidth: "md",
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.update'),
      onClick: onClickedUpdate,
      disabled: disabled
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: metadataPromise,
    setData: setData,
    builder: function builder() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "body2",
        paragraph: true
      }, (0, _core.translate)('users.accesses.description')), /*#__PURE__*/_react["default"].createElement(_material.Card, {
        variant: "outlined"
      }, /*#__PURE__*/_react["default"].createElement(_commons.Griddable, {
        loading: false,
        empty: (0, _core.translate)('apps.empty'),
        hoverable: false,
        noBorderLastRow: true,
        items: apps,
        getId: function getId(app) {
          return app.id;
        },
        columns: [{
          title: (0, _core.translate)('apps.single'),
          converter: function converter(app) {
            return app.name;
          },
          id: 'app',
          xs: 4
        }, {
          title: (0, _core.translate)('roles.title'),
          converter: function converter(app) {
            var _a, _b;
            return /*#__PURE__*/_react["default"].createElement(_AppRolesSelect["default"], {
              app: app,
              roles: roles,
              selected: (_b = (_a = policy === null || policy === void 0 ? void 0 : policy.role_ids) !== null && _a !== void 0 ? _a : defaultRoles) !== null && _b !== void 0 ? _b : [],
              registerInner: registerInner
            });
          },
          id: 'roles',
          xs: true
        }]
      })));
    }
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(UserAccessForm);